export default function deleteTextFromStringByIndex(
    string: string,
    startIndex: number,
    endIndex: number
) {
    return string.slice(0, startIndex) + string.slice(endIndex, string.length);
}
